const mindspore={
    toolsImg: require("@/assets/icon/mindespore.svg"),
        toolsTitle: "昇思MindSpore",
        toolsTag: "开发框架",
        toolsDes:"昇思MindSpore全场景AI框架，集核心框架、模型、开发套件等于一体，助力产业智能升级",


        toolsChild:[
            {
                toolsChildId: 0,
                toolsTitle: "核心框架",
                cardList:[
                            {
                                cardImg:require("@/assets/icon/mindespore.svg"),
                                cardTitle:"MindSpore",
                                cardDes:"MindSpore核心框架",
                                cardLink:"https://gitee.com/mindspore/mindspore"
                            },
                            {
                                cardImg:require("@/assets/icon/mindespore.svg"),
                                cardTitle:"MindSpore Lite",
                                cardDes:"极速、极智、极简的AI引擎",
                                cardLink:"https://gitee.com/mindspore/mindspore/tree/master/mindspore/lite"
                            },

                            {
                                cardImg:require("@/assets/icon/mindespore.svg"),
                                cardTitle:"MindSpore AKG",
                                cardDes:"融合算子加速框架",
                                cardLink:"https://gitee.com/mindspore/akg"
                            },
                        ]
            },
            {
                toolsChildId: 1,
                toolsTitle: "工具及套件-工具组件",
                cardList:[
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Insight",
                        cardDes:"MindSpore Insight是一款可视化调试调优工具，帮助用户获得更优的模型精度和性能。",
                        cardLink:"https://gitee.com/mindspore/mindinsight"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindArmour",
                        cardDes:"MindArmour关注AI的安全和隐私问题。致力于增强模型的安全可信、保护用户的数据隐私。",
                        cardLink:"https://gitee.com/mindspore/mindarmour"
                    },

                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Serving",
                        cardDes:"MindSpore Serving是一款轻量级、高性能的服务工具，帮助用户在生产环境中高效部署在线推理服务。",
                        cardLink:"https://gitee.com/mindspore/serving"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Golden Stick",
                        cardDes:"MindSpore Golden Stick是一款模型压缩算法工具，降低AI部署时算力、内存和电量的消耗，使能全场景AI部署。",
                        cardLink:"https://gitee.com/mindspore/golden-stick"
                    },
                ]
            },
            {
                toolsChildId: 2,
                toolsTitle: "工具及套件-领域套件与扩展包",
                cardList:[
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore NLP",
                        cardDes:"自然语言处理领域套件",
                        cardLink:"https://github.com/mindspore-lab/mindnlp"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore CV",
                        cardDes:"计算机视觉领域套件",
                        cardLink:"https://github.com/mindspore-lab/mindcv"
                    },

                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Audio",
                        cardDes:"音频领域套件",
                        cardLink:"https://github.com/mindspore-lab/mindaudio"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore OCR",
                        cardDes:"OCR领域套件",
                        cardLink:"https://github.com/mindspore-lab/mindocr"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore YOLO",
                        cardDes:"YOLO系列算法套件",
                        cardLink:"https://github.com/mindspore-lab/mindyolo"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Reinforcement",
                        cardDes:"强化学习套件",
                        cardLink:"https://github.com/mindspore-lab/mindrl"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore ModelZoo",
                        cardDes:"MindSpore模型库",
                        cardLink:"https://gitee.com/mindspore/models"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Hub",
                        cardDes:"MindSpore预训练模型应用工具",
                        cardLink:"https://gitee.com/mindspore/hub"
                    },
                ]
            },
            {
                toolsChildId: 3,
                toolsTitle: "工具及套件-科学计算套件",
                cardList:[
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore SciAI",
                        cardDes:"AI4SCI高频模型套件",
                        cardLink:"https://gitee.com/mindspore/mindscience/tree/master/SciAI"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Elec",
                        cardDes:"AI电磁仿真领域套件",
                        cardLink:"https://gitee.com/mindspore/mindscience/tree/master/MindElec"
                    },

                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore SPONGE",
                        cardDes:"计算生物领域套件",
                        cardLink:"https://gitee.com/mindspore/mindscience/tree/master/MindSPONGE"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Flow",
                        cardDes:"流体仿真领域套件",
                        cardLink:"https://gitee.com/mindspore/mindscience/tree/master/MindFlow"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Earth",
                        cardDes:"地球科学领域套件",
                        cardLink:"https://gitee.com/mindspore/mindscience/tree/master/MindEarth"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Chemistry",
                        cardDes:"化学材料领域套件",
                        cardLink:"https://gitee.com/mindspore/mindscience/tree/master/MindChemistry"
                    },
                    {
                        cardImg:require("@/assets/icon/mindespore.svg"),
                        cardTitle:"MindSpore Quantum",
                        cardDes:"量子计算领域套件",
                        cardLink:"https://gitee.com/mindspore/mindquantum"
                    },

                ]
            },
    ],
};
export default mindspore;